// Şans Çarkı Modülü
window.wheel = {
    canvas: null,
    ctx: null,
    segments: [
        { name: "TARİH", color: "#FFC107", key: "tarih" }, // Gold
        { name: "COĞRAFYA", color: "#00E5FF", key: "cografya" }, // Cyan
        { name: "PSİKOLOJİ", color: "#AA00FF", key: "psikoloji" }, // Purple
        { name: "SOSYOLOJİ", color: "#FF6D00", key: "sosyoloji" }, // Orange
        { name: "EDEBİYAT", color: "#FF4081", key: "edebiyat" }, // Pink
        { name: "FEN BİL.", color: "#00E676", key: "fen_bilimleri" }, // Green
        { name: "SİYASET", color: "#D50000", key: "siyaset" }, // Red
        { name: "DİN", color: "#1abc9c", key: "din" }, // Turquoise
        { name: "SİNEMA", color: "#E50914", key: "sinema" }, // Netflix Red
        { name: "SPOR", color: "#2196f3", key: "spor" }, // Blue
        { name: "MİTOLOJİ", color: "#9C27B0", key: "mitoloji" } // Purple/Mystic
    ],
    currentRotation: 0,
    isSpinning: false,
    spinCount: 10,
    collectedQuestions: [],
    winningSegmentIndex: -1, // Highlight için
    animationId: null, // Track animation frame
    audio: new Audio(new URL('../assets/SFX/çark.mp3', import.meta.url).href), // Sound Effect
    audioSuccess: new Audio(new URL('../assets/SFX/bimbom.mp3', import.meta.url).href), // Result Sound

    init: function (targetCanvasId = null) {
        // [MODIFIED] Canvas Seçim Mantığı Güncellendi
        let selectedCanvas = null;

        if (targetCanvasId) {
            // Eğer spesifik bir ID verildiyse onu kullan
            selectedCanvas = document.getElementById(targetCanvasId);
        } else {
            // Otomatik seçim: Görünür olanı bulmaya çalış
            const normalCanvas = document.getElementById('wheel-canvas');
            const wrCanvas = document.getElementById('wr-wheel-canvas');

            // offsetParent null ise element gizlidir (display: none)
            if (normalCanvas && normalCanvas.offsetParent) {
                selectedCanvas = normalCanvas;
            } else if (wrCanvas && wrCanvas.offsetParent) {
                selectedCanvas = wrCanvas;
            } else {
                // Hiçbiri görünür değilse varsayılanı al
                selectedCanvas = normalCanvas || wrCanvas;
            }
        }

        this.canvas = selectedCanvas;
        if (!this.canvas) return;

        this.setupCanvas();

        // Setup Audio
        this.audio.loop = true;
        const currentSFXVol = (window.audio && window.audio.sfxVolume !== undefined) ? window.audio.sfxVolume : 0.6;
        this.audio.volume = currentSFXVol * 0.4;
        this.audioSuccess.volume = currentSFXVol * 0.6;

        // Setup Buttons (Normal)
        const wheelBtn = document.getElementById('wheel-btn');
        if (wheelBtn) {
            wheelBtn.addEventListener('click', () => {
                this.canvas = document.getElementById('wheel-canvas'); // Switch to main
                this.ctx = this.canvas.getContext('2d');
                this.openWheelScreen();
            });
        }

        const spinBtn = document.getElementById('spin-btn');
        if (spinBtn) {
            spinBtn.addEventListener('click', () => this.spin());
        }

        const startBtn = document.getElementById('start-wheel-game-btn');
        if (startBtn) {
            startBtn.addEventListener('click', () => {
                game.startCustomGame(this.collectedQuestions);
            });
        }

        const autoSpinBtn = document.getElementById('auto-spin-btn');
        if (autoSpinBtn) {
            autoSpinBtn.addEventListener('click', () => this.autoSpin());
        }

        // Waiting Room için init
        const wrSpinBtn = document.getElementById('wr-spin-btn');
        // Click event'i multiplayer.js tarafından yönetiliyor, buraya eklemeye gerek yok.

        // Draw initial wheel
        this.draw();
    },

    openWheelScreen: function () {
        // Reset everything
        this.exit(); // Ensure any previous state is cleared

        this.spinCount = 10;
        this.collectedQuestions = [];
        this.isSpinning = false;
        this.winningSegmentIndex = -1;
        this.currentRotation = 0; // Start fresh

        // [FIX] Router üzerinden ekranı göster (Dinamik yükleme desteği)
        if (window.ui && window.ui.showScreen) {
            window.ui.showScreen('wheel-screen');
        } else if (window.Router && window.Router.showScreen) {
            window.Router.showScreen('wheel-screen');
        }

        // Elementlerin DOM'a eklenmesini bekle
        setTimeout(() => {
            // Canvas'ı yeniden bul
            this.canvas = document.getElementById('wheel-canvas');
            if (this.canvas) {
                this.setupCanvas();
            }

            const spinCountEl = document.getElementById('spin-count');
            const spinResultEl = document.getElementById('spin-result-text');
            const spinBtn = document.getElementById('spin-btn');
            const collectedList = document.getElementById('collected-questions-list');
            const wheelActions = document.getElementById('wheel-actions');

            if (spinCountEl) spinCountEl.innerText = this.spinCount;
            if (spinResultEl) spinResultEl.innerText = "Kategorini Seç!";
            if (spinBtn) spinBtn.disabled = false;
            if (collectedList) collectedList.innerHTML = '';
            if (wheelActions) wheelActions.classList.add('hidden');

            // Stop audio if playing
            this.audio.pause();
            this.audio.currentTime = 0;

            // Start Background Music
            if (window.audio && window.audio.playMusic) {
                window.audio.playMusic('gaddar_cark.mp3', true);
            }

            // Event listener'ları yeniden bağla
            this.bindScreenListeners();

            this.draw();
        }, 50);
    },

    // [NEW] Event listener'ları ayrı fonksiyona taşındı
    bindScreenListeners: function () {
        const spinBtn = document.getElementById('spin-btn');
        if (spinBtn && !spinBtn._wheelBound) {
            spinBtn.addEventListener('click', () => this.spin());
            spinBtn._wheelBound = true;
        }

        const startBtn = document.getElementById('start-wheel-game-btn');
        if (startBtn && !startBtn._wheelBound) {
            startBtn.addEventListener('click', () => {
                game.startCustomGame(this.collectedQuestions);
            });
            startBtn._wheelBound = true;
        }

        const autoSpinBtn = document.getElementById('auto-spin-btn');
        if (autoSpinBtn && !autoSpinBtn._wheelBound) {
            autoSpinBtn.addEventListener('click', () => this.autoSpin());
            autoSpinBtn._wheelBound = true;
        }
    },

    exit: function () {
        this.stopAutoSpin();
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }
        this.isSpinning = false;
        this.audio.pause();
        this.audio.loop = false; // [FIX] Ensure loop is off
        this.audio.currentTime = 0;

        // Reset Visuals immediately
        const soloText = document.getElementById('spin-result-text');
        if (soloText) soloText.innerText = "Kategorini Seç!";

        // Reset Highlight
        this.winningSegmentIndex = -1;
        this.draw();
    },

    setupCanvas: function () {
        if (!this.canvas) return;

        // Reset transform to avoid additive scaling if re-initialized
        const existingCtx = this.canvas.getContext('2d');
        if (existingCtx) {
            existingCtx.setTransform(1, 0, 0, 1, 0, 0);
        }

        // [FIX] Calculate size: prioritize offsetWidth, fallback to CSS default (440) or 500
        // Use a small delay if possible, or just check parent if offsetWidth is 0
        let size = this.canvas.offsetWidth;
        if (!size || size < 20) {
            const container = this.canvas.parentElement;
            if (container && container.offsetWidth > 20) {
                size = container.offsetWidth;
            } else {
                size = 440; // Default fallback for desktop
            }
        }

        // Cap size for sanity
        if (size > 800) size = 500;

        this.canvas.width = size * 2;
        this.canvas.height = size * 2;
        this.canvas.style.width = `${size}px`;
        this.canvas.style.height = `${size}px`;

        this.ctx = this.canvas.getContext('2d');
        this.ctx.scale(2, 2);

        console.log(`[Wheel] Canvas Setup: ${size}px (Res: ${this.canvas.width}x${this.canvas.height})`);
    },

    draw: function () {
        if (!this.ctx || !this.canvas) return;
        const ctx = this.ctx;
        const width = this.canvas.width / 2; // Account for 2x scale
        const height = this.canvas.height / 2;
        const radius = width / 2 - 10;
        const arc = (2 * Math.PI) / this.segments.length;

        ctx.clearRect(0, 0, width, height);

        // --- OUTER GLOW & BORDER ---
        ctx.save();
        ctx.translate(width / 2, height / 2);

        // Outer Neon Ring
        ctx.beginPath();
        ctx.arc(0, 0, radius + 5, 0, Math.PI * 2);
        ctx.strokeStyle = "rgba(255, 215, 0, 0.3)";
        ctx.lineWidth = 10;
        ctx.stroke();

        ctx.rotate(this.currentRotation);

        this.segments.forEach((seg, i) => {
            const angle = i * arc;
            ctx.beginPath();

            // Segment Gradient for Premium Look
            const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, radius);
            grad.addColorStop(0, this.adjustColor(seg.color, -20)); // Darker center
            grad.addColorStop(1, seg.color);

            ctx.fillStyle = grad;

            // Highlight Logic
            if (this.winningSegmentIndex === i) {
                ctx.shadowBlur = 40;
                ctx.shadowColor = "#fff";
                ctx.fillStyle = "#fff"; // Flash effect
            } else {
                ctx.shadowBlur = 0;
            }

            ctx.moveTo(0, 0);
            ctx.arc(0, 0, radius, angle, angle + arc);
            ctx.lineTo(0, 0);
            ctx.fill();

            // Inner gloss/gradient overlay
            if (this.winningSegmentIndex === i) {
                ctx.save();
                ctx.globalAlpha = 0.7;
                ctx.fillStyle = seg.color;
                ctx.fill();
                ctx.restore();
            }

            // Segment Borders
            ctx.strokeStyle = "rgba(255, 255, 255, 0.15)";
            ctx.lineWidth = 2;
            ctx.stroke();

            // --- TEXT ---
            ctx.save();
            const textAngle = angle + arc / 2;

            // [FIX] Staggering (Zikzak) Yerleşim
            // Çift indeksli dilimler biraz daha merkeze, tekler biraz daha dışa
            // Varsayılan: 0.72
            // Yeni: 0.65 (iç) ve 0.78 (dış)
            const isBase = i % 2 === 0;
            const distFactor = isBase ? 0.62 : 0.78;

            ctx.translate(Math.cos(textAngle) * radius * distFactor, Math.sin(textAngle) * radius * distFactor);
            ctx.rotate(textAngle + Math.PI / 2);

            ctx.fillStyle = "#fff";

            // [FIX] Dinamik Font Boyutu
            // Dilim sayısı arttıkça font küçülür
            let baseFontSize = 17;
            if (this.segments.length > 10) baseFontSize = 13;
            if (this.segments.length > 12) baseFontSize = 11;

            const fontSize = this.winningSegmentIndex === i ? (baseFontSize + 4) : baseFontSize;

            ctx.font = `800 ${fontSize}px 'Outfit', sans-serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";

            // Text Shadow for Readability
            ctx.shadowBlur = 10;
            ctx.shadowColor = "rgba(0,0,0,0.8)";
            ctx.fillText(seg.name, 0, 0);
            ctx.restore();
        });

        ctx.restore();

        // --- STATIC CENTER HOLE ---
        ctx.save();
        ctx.translate(width / 2, height / 2);
        ctx.beginPath();
        ctx.arc(0, 0, radius * 0.25, 0, Math.PI * 2);
        ctx.fillStyle = "#111";
        ctx.shadowBlur = 15;
        ctx.shadowColor = "rgba(0,0,0,1)";
        ctx.fill();
        ctx.strokeStyle = "rgba(255, 215, 0, 0.5)";
        ctx.lineWidth = 3;
        ctx.stroke();
        ctx.restore();
    },

    // Helper to darken/lighten colors
    adjustColor: function (hex, percent) {
        const num = parseInt(hex.replace("#", ""), 16),
            amt = Math.round(2.55 * percent),
            R = (num >> 16) + amt,
            G = (num >> 8 & 0x00FF) + amt,
            B = (num & 0x0000FF) + amt;
        return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
    },

    spin: function (targetKey = null, isFast = false) {
        // [NEW] Online Mod Kontrolü
        if (window.multiplayer && window.multiplayer.room && !targetKey) {
            // Eğer host ise ve bekleme odasındaysak
            const waitingRoom = document.getElementById('waiting-room-screen');
            if (waitingRoom && waitingRoom.classList.contains('active')) {
                // Multi'de spin isteğini sunucuya gönder
                window.multiplayer.room.send("requestSpin");
                return;
            }
        }

        // Eğer targetKey varsa, hedefimiz bellidir. Yoksa random.
        if (this.isSpinning) return;
        // Solo modda spinCount kontrolü var, multi'de yok.
        if (!targetKey && this.spinCount <= 0) return;

        this.isSpinning = true;
        if (!targetKey) this.spinCount--; // Sadece solo'da düş

        this.winningSegmentIndex = -1; // Reset highlight

        // UI Updates (Solo & Multi)
        const soloCount = document.getElementById('spin-count');
        if (soloCount) soloCount.innerText = this.spinCount;

        const soloSpinBtn = document.getElementById('spin-btn');
        if (soloSpinBtn) soloSpinBtn.disabled = true;

        const soloText = document.getElementById('spin-result-text');
        if (soloText) soloText.innerText = "Çevriliyor...";

        const wrText = document.getElementById('wr-spin-result-text');
        if (wrText) wrText.innerText = "Çevriliyor...";

        if (window.AccessibilityManager) {
            window.AccessibilityManager.announce("Çark çevriliyor, lütfen bekleyin...", "polite");
        }

        // Play Sound
        this.audio.loop = true;
        this.audio.playbackRate = 1.0;
        this.audio.currentTime = 0;
        this.audio.play().catch(e => console.log("Audio permission error:", e));

        let velocity = Math.random() * 0.5 + 0.5; // Başlangıç hızı
        // Friction tuning:
        let friction = isFast ? 0.95 : 0.97;

        // Ensure animationId is cleared before starting new
        if (this.animationId) cancelAnimationFrame(this.animationId);

        let targetAngle = -1;
        if (targetKey) {
            const segIndex = this.segments.findIndex(s => s.key === targetKey);
            if (segIndex !== -1) {
                // Hedef segmentin merkez açısı
                const arc = (2 * Math.PI) / this.segments.length;
                const segmentCenter = (segIndex * arc) + (arc / 2);
                const pointerPos = 3 * Math.PI / 2;

                // Hedef net dönüş açısı (birkaç tur attıktan sonra)
                const extraSpins = (3 + Math.floor(Math.random() * 2)) * 2 * Math.PI; // Reduced extra spins

                targetAngle = (pointerPos - segmentCenter) + extraSpins;

                // Negatif veya pozitif düzeltmeler
                while (targetAngle < this.currentRotation) {
                    targetAngle += 2 * Math.PI;
                }
            }
        }

        // Animasyon Loop
        if (targetKey && targetAngle !== -1) {
            // TARGET MODE (Deterministic)
            const duration = 2500; // 2.5s for online sync
            const startTime = performance.now();
            const startRotation = this.currentRotation;
            const distance = targetAngle - startRotation;

            const animateTarget = (time) => {
                try {
                    const elapsed = time - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    // Ease Out Cubic
                    const ease = 1 - Math.pow(1 - progress, 3);

                    this.currentRotation = startRotation + (distance * ease);

                    const remaining = 1 - progress;
                    // Daha yumuşak ses değişimi (0.8x - 1.2x arası)
                    this.audio.playbackRate = 0.8 + (remaining * 0.4);

                    this.draw();

                    if (progress < 1) {
                        this.animationId = requestAnimationFrame(animateTarget);
                    } else {
                        this.isSpinning = false;
                        this.finishSpin(targetKey);
                    }
                } catch (e) {
                    console.error("Wheel Animation Error:", e);
                    this.isSpinning = false;
                    this.finishSpin(targetKey);
                }
            };
            this.animationId = requestAnimationFrame(animateTarget);

        } else {
            // RANDOM MODE (Physics)
            const animateMap = () => {
                try {
                    if (velocity > 0.002) {
                        velocity *= friction;
                        this.currentRotation += velocity;

                        // Hıza göre ses perdesi (0.5 - 1.5 arası)
                        const rate = 0.5 + Math.min(velocity * 2, 1.0);
                        this.audio.playbackRate = rate;

                        this.draw();
                        this.animationId = requestAnimationFrame(animateMap);
                    } else {
                        this.isSpinning = false;
                        this.finishSpin();
                    }
                } catch (e) {
                    console.error("Wheel Animation Error (Free Spin):", e);
                    this.isSpinning = false;
                    this.finishSpin();
                }
            };
            this.animationId = requestAnimationFrame(animateMap);
        }
    },

    // Alias for remote call
    spinTo: function (key) {
        this.spin(key);
    },

    spinOnline: function (key, onComplete) {
        console.log("🎡 spinOnline called for:", key);
        this.spin(key);
        // [TODO] The current spin() doesn't take a callback, 
        // but we can monitor isSpinning to fire onComplete if needed.
        // For now, the animation duration is fixed (2.5s).
        if (onComplete) setTimeout(onComplete, 3000);
    },

    finishSpin: function (forcedKey = null) {
        // Stop Sound COMPLETELY
        if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
            this.audio.loop = false;
        }
        this.animationId = null; // Clear ID

        // EĞER ÇARK EKRANINDAN ÇIKILDIYSA SONUÇ GÖSTERME
        const wheelScreen = document.getElementById('wheel-screen');
        const waitingRoomScreen = document.getElementById('waiting-room-screen');
        const isWheelVisible = (wheelScreen && wheelScreen.classList.contains('active')) ||
            (waitingRoomScreen && waitingRoomScreen.classList.contains('active'));

        if (!isWheelVisible) {
            this.isSpinning = false; // Reset flag even if not visible
            return;
        }

        // Play Success Sound
        if (this.audioSuccess) {
            // [MODIFIED] Create a transient clone to allow overlapping without "clogging"
            const successClone = this.audioSuccess.cloneNode();
            successClone.volume = (window.audio && window.audio.sfxVolume !== undefined) ? window.audio.sfxVolume * 0.6 : this.audioSuccess.volume;
            successClone.play().catch(e => console.log("Audio permission error:", e));
        }

        // Hangi dilim geldi?
        const arc = (2 * Math.PI) / this.segments.length;
        let angle = this.currentRotation % (2 * Math.PI);

        const pointerAngle = 3 * Math.PI / 2; // 270 degrees (Top)
        let effectiveAngle = (pointerAngle - angle) % (2 * Math.PI);
        if (effectiveAngle < 0) effectiveAngle += 2 * Math.PI;

        const segmentIndex = Math.floor(effectiveAngle / arc);
        this.winningSegmentIndex = segmentIndex; // Set highlight
        this.draw(); // Redraw with highlight

        const selectedSegment = this.segments[segmentIndex];

        // UI UPDATES
        const soloText = document.getElementById('spin-result-text');
        const wrText = document.getElementById('wr-spin-result-text');

        const resultHTML = `GELEN: <span style="color:${selectedSegment.color}; text-shadow: 0 0 15px ${selectedSegment.color}">${selectedSegment.name}</span>`;

        if (soloText) soloText.innerHTML = resultHTML;
        if (wrText) wrText.innerHTML = resultHTML;

        if (window.AccessibilityManager) {
            window.AccessibilityManager.announce("Çark durdu. Gelen kategori: " + selectedSegment.name, "assertive");
        }

        // Reset spinning flag
        this.isSpinning = false;

        // Eğer forcedKey varsa (Multiplayer), sunucudan gelen kategoriyi listeye ekle
        if (forcedKey) {
            this.updateOnlineCollectedCategories(selectedSegment);
        } else {
            // Solo Mode
            this.addRandomQuestion(selectedSegment.key, selectedSegment);
            if (this.spinCount > 0) {
                const sb = document.getElementById('spin-btn');
                if (sb) sb.disabled = false;
            } else {
                if (soloText) soloText.innerHTML += " <br><span style='font-size:0.8em; color:#fff'>HAKKIN BİTTİ!</span>";
                const wheelActionsEl = document.getElementById('wheel-actions');
                if (wheelActionsEl) wheelActionsEl.classList.remove('hidden');
            }
        }
    },

    // [NEW] Added 1.0s delay as requested (matched with server)
    updateOnlineCollectedCategories: function (segmentInfo) {
        setTimeout(() => {
            const listContainer = document.getElementById('wr-collected-categories-list') || document.getElementById('collected-questions-list');
            if (listContainer) {
                const item = document.createElement('div');
                item.className = 'slot filled'; // Using the slot style from wr_styles.css
                item.style.borderColor = segmentInfo.color;
                item.style.background = segmentInfo.color;
                item.style.color = "#000"; // Dark text on bright background
                item.style.boxShadow = `0 0 15px ${segmentInfo.color}`;

                // Map segment name to a short initial or icon if needed, but here we show full name
                item.innerHTML = `<span style="font-weight:900;">${segmentInfo.name}</span>`;

                // Increase width for the slot if it's a list item
                item.style.width = "auto";
                item.style.minWidth = "100px";
                item.style.borderRadius = "8px";
                item.style.padding = "4px 12px";

                listContainer.appendChild(item);

                // Scroll to bottom
                const parent = listContainer.parentElement;
                if (parent) parent.scrollTop = parent.scrollHeight;
            }
        }, 600);
    },

    addRandomQuestion: async function (categoryKey, segmentInfo) {
        let pool = [];

        // 1. API'den çekmeyi dene
        if (window.TeableQuestionService) {
            try {
                pool = await window.TeableQuestionService.fetchByCategory(categoryKey);
            } catch (e) {
                console.warn('[Wheel] API hatası, yerel fallback...', e);
            }
        }

        // 2. Fallback: yerel veri
        if (!pool || pool.length === 0) {
            if (window.questionsData && window.questionsData[categoryKey]) {
                const catData = window.questionsData[categoryKey];
                Object.values(catData).forEach(arr => {
                    if (Array.isArray(arr)) pool = pool.concat(arr);
                });
            }
        }

        if (pool.length === 0) {
            console.error("Kategori verisi yok:", categoryKey);
            return;
        }

        const randomQ = pool[Math.floor(Math.random() * pool.length)];
        this.collectedQuestions.push(randomQ);

        // Listeye ekle
        const listContainer = document.getElementById('collected-questions-list');
        if (listContainer) {
            const item = document.createElement('div');
            item.className = 'slot filled';
            item.style.borderColor = segmentInfo.color;
            item.innerHTML = `<span style="font-weight:800;">${segmentInfo.name}</span>`;

            // Add Remove Button
            const removeBtn = document.createElement('button');
            removeBtn.innerText = "X";
            removeBtn.style.marginLeft = "10px";
            removeBtn.style.background = "red";
            removeBtn.style.border = "none";
            removeBtn.style.color = "white";
            removeBtn.style.borderRadius = "50%";
            removeBtn.style.cursor = "pointer";
            removeBtn.onclick = () => {
                item.remove();
            };
            item.appendChild(removeBtn);

            listContainer.appendChild(item);

            // Scroll to bottom
            const parent = document.getElementById('wheel-results-container');
            if (parent) parent.scrollTop = parent.scrollHeight;
        }
    },

    autoSpinTimeout: null,
    autoSpinInterval: null,

    autoSpin: function () {
        if (this.isSpinning || this.spinCount <= 0) return;

        const autoBtn = document.getElementById('auto-spin-btn');
        const spinBtn = document.getElementById('spin-btn');

        // Butonları kilitle
        if (autoBtn) autoBtn.disabled = true;
        if (spinBtn) spinBtn.disabled = true;

        const performSpin = () => {
            if (this.spinCount > 0) {
                // Call spin with isFast = true
                this.spin(null, true);

                this.autoSpinInterval = setInterval(() => {
                    if (!this.isSpinning) {
                        clearInterval(this.autoSpinInterval);
                        this.autoSpinInterval = null;

                        // Spin bitti, biraz bekle ve tekrar çevir
                        if (this.spinCount > 0) {
                            this.autoSpinTimeout = setTimeout(performSpin, 100); // Reduced delay to 100ms
                        } else {
                            // Bitti
                            if (autoBtn) autoBtn.disabled = false;
                        }
                    }
                }, 200); // Check faster
            }
        };

        performSpin();
    },

    stopAutoSpin: function () {
        if (this.autoSpinTimeout) {
            clearTimeout(this.autoSpinTimeout);
            this.autoSpinTimeout = null;
        }

        if (this.autoSpinInterval) {
            clearInterval(this.autoSpinInterval);
            this.autoSpinInterval = null;
        }

        this.isSpinning = false;
        this.audio.pause();
        this.audio.currentTime = 0;

        const autoBtn = document.getElementById('auto-spin-btn');
        const spinBtn = document.getElementById('spin-btn');

        if (autoBtn) autoBtn.disabled = false;
        if (spinBtn && this.spinCount > 0) spinBtn.disabled = false;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    wheel.init();
});
